<div class="sip-condition-groups">
    <legend>SIP Condition Groups</legend>
    <arm-layout [summaryTitle]="'SIP condition groups summary'" class="sip-condition-groups-layout">
        <div header>
            <div class="search-container">
                <div class="search-container">
                    <client-filter (onFilter)="onFilter($event)"></client-filter>
                </div>

                <div class="action-buttons">
                    <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized"
                                    (refreshClick)="refresh()"
                                    (deleteClick)="removeItem()" [disableDelete]="!selection || isUnauthorized"
                                    (editClick)="editItem()" [disableEdit]="!selection || isUnauthorized">
                    </arm-action-bar>
                </div>
            </div>

            <div class="action-buttons">
                <arm-action-bar (addClick)="addItem()" [disableAdd]="isUnauthorized" (deleteClick)="removeItem()"
                                [disableDelete]="isUnauthorized || !selection || selection.length === 0"
                                (refreshClick)="refresh()" (editClick)="editItem()"
                                [disableEdit]="isUnauthorized || !selection || selection.length === 0"></arm-action-bar>
            </div>
        </div>
        <div summary>
            <sip-condition-groups-summary [selection]="selection"></sip-condition-groups-summary>
        </div>

        <div main>
            <arm-table [displayedColumns]="displayedColumns"
                       (onSelection)="onSelection($event)" [data]="items"
                       [isMultipleSelection]="false"
                       [isClientSide]="true" [filter]="filter">
            </arm-table>
        </div>
    </arm-layout>
</div>
